import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FireGuestAccessService } from '../../shared/services/fire-guest-access.service';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import firebase from 'firebase/compat/app';
import { environment as env } from '@env/environment';

@Component({
  selector: 'app-landing',
  template: `<!-- you’ll provide HTML -->`,
})
export class LoginComponent implements OnInit {
  uid: string | null = null;
  hall: string | null = null;      // optional: read from query param or your UI
  name: string = '';
  consentChecked = false;

  // simple UI flags you can bind to
  submitting = false;
  errorMsg = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fireGuest: FireGuestAccessService,
    private afs: AngularFirestore
  ) {}

  ngOnInit(): void {
        this.uid  = this.route.snapshot.queryParamMap.get('uid');
   

    if (!this.uid) {
      this.errorMsg = 'Invalid or missing ID. Please use your personal link.';
    }
    
     console.log('env projectId:', env.firebase?.projectId);
    console.log('firebase.apps.length:', firebase.apps.length);

  

       this.afs
      .collection('clicked')
      .add({viewer: this.uid, consent:true, ts: Date.now() })
      .then(() => console.log('Firestore write OK'))
      .catch((err) => console.error('Firestore write FAILED', err));

  }
  
  


  // Call this on your “Watch” button
  async onContinue(): Promise<void> {
    this.errorMsg = '';
    if (!this.uid) {
      this.errorMsg = 'Missing ID.';
      return;
    }
    const trimmed = (this.name || '').trim();
    if (!this.consentChecked) {
      this.errorMsg = 'Please check the consent box.';
      return;
    }
    if (!trimmed) {
      this.errorMsg = 'Please enter your name.';
      return;
    }

    try {
      this.submitting = true;

      // Persist consent + name to a single doc per uid
      await this.fireGuest.recordConsent({
        uid: this.uid,
        name: trimmed,
        eventId: env.selectedEvent,
        hall: this.hall,                 // null if not provided
        path: this.router.url,
        consent: true,
      });

      // Build navigation to live page
      // If you use a hall segment in the path, prefer that. Otherwise pass as query.
      const hallSeg = this.hall ? `/${this.hall}` : '';
      this.router.navigate([`/live${hallSeg}`], {
        queryParams: {
          uid: this.uid,
          name: trimmed,
        },
        queryParamsHandling: 'merge', // keeps extra params if any
      });
    } catch (e: any) {
      console.error(e);
      this.errorMsg = 'Something went wrong. Please try again.';
    } finally {
      this.submitting = false;
    }
  }
}
